module.exports = __webpack_public_path__ + "img/footBox_icon.be311a5b.png";